import uspLogo from "./USPlogo.png";
import footerRightImg from "./footerRightImg.png";
import footerLeftImg from "./footerLeftImg.png";
import profileIcon from "./profilIcon.png";
import locationIcon from "./locationIcon.png";
import facebook from "./facebook.png";
import whatapp from "./whatapp.png";
import linkedin from "./indeed.png";
import youtube from "./youtube.png";
import instagram from "./instagram.png";
import productDemo from "./productDemo.png";
import slider1 from "./homePage1Slider.png";
import slider2 from "./homePage2Slider.png";
import slider3 from "./homePage3Slider.png";
import companyNameImg from "./CompanyNameImg.png";
import CompanyNameText from "./CompanyNameText.png";
import knowAsImg from "./knowAsImg.png";
import homePageVisionCard from "./homePageVisioncard.png";
import homePageMissionCard from "./homePagemissioncard.jpeg";
import homePageChooseCard1 from "./choosePage1Img.png";
import homePageChooseCard2 from "./choosePage2Img.png";
import homePageChooseCard3 from "./choosePage3Img.png";
import homePageChooseCard4 from "./choosePage4Img.png";
import homeDoubleCard1 from "./homeDoubleCard1.jpg";
import homeDoubleCard2 from "./homeDoubleCard2.jpg";
import homeDoubleCard3 from "./homeDoubleCard3.jpg";
import homeDoubleCard4 from "./homeDoubleCard4.jpg";
import homeDoubleCard5 from "./homeDoubleCard5.jpg";
import homeDoubleCard6 from "./homeDoubleCard6.jpg";
import KnowAsServiceHeaderImg from "./knowAsServiceHeader.jpeg";
import knowUsQualityProduct from "./knowUsQualityProduct.png";
import knowUsBulb from "./knowUsBulb.svg";
import knowUsEarthVan from "./knowUsEarth&Van.png";
import knowUsGoldBag from "./knowUsGoldMoneyBag.png";
import chennaiIcon from "./ChennaiIcon.png";
import bangaloreIcon from "./bangalureIcon.png";
import bhubaneshwariIcon from "./bhubaneshwarIcon.png";
import ghaziabadIcon from "./ghaziabadIcon.png";
import hosurIcon from "./hosurIcon.png";
import HYDERABADIcon from "./HYDERABADIcon.png";
import MumbaiIcon from "./MumbaiIcon.png";
import PUDUCHERRYIcon from "./PUDUCHERRYIcon.png";
import VijayawadaIcon from "./VijayawadaIcon.png";
import goaIcon from "./goa.png";
import UspTto03jPrinter from "./uspttoPrinter.png";
import downloadBrochureImg from "./downloadBrochureImg.png";
import foodAndBeverage1 from "./foodandBeverage1.png";
import foodAndBeverage2 from "./foodandbeverage2.png";
import sqCopilot1281 from "./sq-copilot128 1.png";
import USPJEtSTREAM2 from "./USP JEtSTREAM 2.png";
import UspA2120 from "./uspchangeda2120.png";

import stallIcon from "./stall.png";
import stallEventIcon from "./stallevent.png";
import brucoffeeIcon from "./brucoffee.png";
import orangeIcon from "./orange.png";
import pipesIcon from "./pipes.png";
import aluminiumIcon from "./aluminium.png";
import youtueIcon from "./youtubeIcon.png";
import instagramIcon from "./instagramIcon.png";
import facebookIcon from "./facebookIcon.png";
import supportIcon from "./supportIcon.png";
import goldproIcon from "./goldproIcon.png";
import shareImage from "./shareImage.png";
import addressIcon from "./address.png";
import teleIcon from "./tele.png";
import phoneIcon from "./phone.png";
import followIcon from "./follow.png";
import meaageIcon from "./message.png";
import phoneCall from "./Phonecall.png";
import location from "./location.png";
import clockIcon from "./clock.png";
import byIndustryIcon from "./byIndustry.png";
import byIndustryBackIcon from "./industrybackground.png";
import industry1 from "./industry1.png";
import industry2 from "./industry2.png";
import industry3 from "./industry3.png";
import industry4 from "./industry4.png";
import industry5 from "./industry5.png";
import industry6 from "./industry6.png";
import industry7 from "./industry7.png";
import industry8 from "./industry8.png";
import industry9 from "./industry9.png";
import industry10 from "./industry10.png";
import industry11 from "./industry11.png";
import industry12 from "./industry12.png";
import uspstream1 from "./usp_stream_1.png";
import uspstream2 from "./usp_stream_2.png";
import uspstream3 from "./usp_stream_3.png";
import uspstream4 from "./uspchangeda2120.png";
import uspstream5 from "./usp_stream_5.png";
import copilot256 from "./copilot-256.png";
import uspstream6 from "./usp_stream_6.png";
import uspstream7 from "./usp_stream_7.png";
import uspstream8 from "./usp_stream_8.png";
import uspstream9 from "./usp_stream_9.png";
import uspstream10 from "./usp_stream_10.png";
import uspstream11 from "./usp_stream_11.png";
import uspstream12 from "./usp_stream_12.png";
import uspstream13 from "./usp_stream_13.png";
import uspstream14 from "./usp_stream_14.png";
import uspstream15 from "./usp_stream_15.png";
// import uspuvlaser from "./USP UV LASER CODING SYSTEM.png";
import foodanbeverage from "./foodandbeverage.png";
import thermalprinter from "./thermalprinter1.png";
import contactus from "./contacutus.png";
import contactusBottom from "./contactus_bottom.png";
import uspstream16 from "./usp_stream_16.png";
import uspstream17 from "./usp_stream_17.png";
import uspstream18 from "./usp_stream_18.png";
import uspstream19 from "./usp_stream_19.png";
import downloadIcon from "./downloadIcon.png";
import arrowDown from "./arrowDown.png";
import arrowUp from "./arrowUp.png";
import whatsappIcon from "./whatsapp.png";
import slider4 from "./homepageslide4.png";
import slider5 from "./homepageslider5.png";
import usplogin from "./usplogin.png";
import eventbanner from "./eventtbanner.jpg";
import pastevent from "./pastevent.jpg";
import addresstheme from "./addresstheme.jpg"
import keralapack from "./keralapack.jpg"
import fooddrinkexpo from "./fooddrinkexpo.jpg"
import dairyindustry from "./dairyindustry.jpg"
import upcoming_event_july from "./upcoming_event_july.png"

// import uspuvlaser from "./USP UV LASER CODING SYSTEM.png";
// import foodanbeverage from "./foodandbeverage.png";
// import thermalprinter from "./thermalprinter1.png";
const Images = {
  uspLogo: uspLogo,
  whatsappIcon: whatsappIcon,
  footerRightImg: footerRightImg,
  footerLeftImg: footerLeftImg,
  profileIcon: profileIcon,
  locationIcon: locationIcon,
  facebook: facebook,
  whatapp: whatapp,
  linkedin: linkedin,
  youtube: youtube,
  instagram: instagram,
  productDemo: productDemo,
  slider1: slider1,
  slider2: slider2,
  slider3: slider3,
  companyNameImg: companyNameImg,
  CompanyNameText: CompanyNameText,
  knowAsImg: knowAsImg,
  homePageVisionCard: homePageVisionCard,
  homePageMissionCard: homePageMissionCard,
  homePageChooseCard1: homePageChooseCard1,
  homePageChooseCard2: homePageChooseCard2,
  homePageChooseCard3: homePageChooseCard3,
  homePageChooseCard4: homePageChooseCard4,
  homeDoubleCard1: homeDoubleCard1,
  homeDoubleCard2: homeDoubleCard2,
  homeDoubleCard3: homeDoubleCard3,
  homeDoubleCard4: homeDoubleCard4,
  homeDoubleCard5: homeDoubleCard5,
  homeDoubleCard6: homeDoubleCard6,
  KnowAsServiceHeaderImg: KnowAsServiceHeaderImg,
  knowUsQualityProduct: knowUsQualityProduct,
  knowUsBulb: knowUsBulb,
  knowUsEarthVan: knowUsEarthVan,
  knowUsGoldBag: knowUsGoldBag,
  chennaiIcon: chennaiIcon,
  bangaloreIcon: bangaloreIcon,
  bhubaneshwarIcon: bhubaneshwariIcon,
  ghaziabadIcon: ghaziabadIcon,
  hosurIcon: hosurIcon,
  HYDERABADIcon: HYDERABADIcon,
  MumbaiIcon: MumbaiIcon,
  PUDUCHERRYIcon: PUDUCHERRYIcon,
  VijayawadaIcon: VijayawadaIcon,
  goaIcon: goaIcon,
  UspTto03jPrinter: UspTto03jPrinter,
  downloadBrochureImg: downloadBrochureImg,
  foodAndBeverage1: foodAndBeverage1,
  foodAndBeverage2: foodAndBeverage2,
  sqCopilot1281: sqCopilot1281,
  USPJEtSTREAM2: USPJEtSTREAM2,
  UspA2120: UspA2120,
  stallIcon: stallIcon,
  stallEventIcon: stallEventIcon,
  brucoffeeIcon: brucoffeeIcon,
  orangeIcon: orangeIcon,
  pipesIcon: pipesIcon,
  aluminiumIcon: aluminiumIcon,
  youtueIcon: youtueIcon,
  instagramIcon: instagramIcon,
  facebookIcon: facebookIcon,
  supportIcon: supportIcon,
  goldproIcon: goldproIcon,
  shareImage: shareImage,
  addressIcon: addressIcon,
  followIcon: followIcon,
  teleIcon: teleIcon,
  phoneIcon: phoneIcon,
  meaageIcon: meaageIcon,
  phoneCall: phoneCall,
  location: location,
  clockIcon: clockIcon,
  byIndustryIcon: byIndustryIcon,
  byIndustryBackIcon: byIndustryBackIcon,
  industry1: industry1,
  industry2: industry2,
  industry3: industry3,
  industry4: industry4,
  industry5: industry5,
  industry6: industry6,
  industry7: industry7,
  industry8: industry8,
  industry9: industry9,
  industry10: industry10,
  industry11: industry11,
  industry12: industry12,
  uspstream1: uspstream1,
  uspstream2: uspstream2,
  uspstream3: uspstream3,
  uspstream4: uspstream4,
  uspstream5: uspstream5,
  uspstream6: uspstream6,
  uspstream7: uspstream7,
  uspstream8: uspstream8,
  uspstream9: uspstream9,
  uspstream10: uspstream10,
  uspstream11: uspstream11,
  uspstream12: uspstream12,
  uspstream13: uspstream13,
  uspstream14: uspstream14,
  uspstream15: uspstream15,
  // uspuvlaser: uspuvlaser,
  foodanbeverage: foodanbeverage,
  thermalprinter: thermalprinter,
  contactus: contactus,
  contactusBottom: contactusBottom,
  uspstream16: uspstream16,
  uspstream17: uspstream17,
  uspstream18: uspstream18,
  uspstream19: uspstream19,
  // uspuvlaser: uspuvlaser,
  foodanbeverage: foodanbeverage,
  thermalprinter: thermalprinter,
  arrowDown: arrowDown,
  arrowUp: arrowUp,
  copilot256: copilot256,
  downloadIcon: downloadIcon,
  slider4: slider4,
  slider5: slider5,
  usplogin: usplogin,
  eventbanner: eventbanner,
  pastevent,
  addresstheme,
  keralapack,
  fooddrinkexpo,
  dairyindustry,
  upcoming_event_july,
};

export default Images;
